import React from 'react'
import { money } from '../financial/formatting'
import { DIRECTION_LABEL, dayLabel, netBalanceRows } from './model'

// Where the partner and Kickoff stand at the end of the range - cumulative,
// not just this period (companies/partner_workspace.net_balance()). Only the
// partner's side of the money: their earnings, what they bought, what moved.
//
// A balance declared by the old system sits under the rows, outside the
// figure: it can describe debt the computed side already carries, so adding
// it in could count it twice.
export default function NetBalance({ net, previous = [] }) {
  const rows = netBalanceRows(net)

  return (
    <section id="pw-statement" className="pw-net" aria-label="Net balance">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, minWidth: 0 }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1.2, color: 'var(--kpi-hero-muted)' }}>
          NET BALANCE · AS OF {dayLabel(net.as_of).toUpperCase()}
        </div>
        <div className="pw-num pw-title" style={{ fontSize: 'clamp(32px, 5vw, 44px)', fontWeight: 800, color: 'var(--kpi-hero-fg)', lineHeight: 1.05 }}>
          {money(net.amount)}
        </div>
        <span style={{
          alignSelf: 'flex-start', padding: '5px 12px', borderRadius: 999,
          background: 'var(--kpi-hero-fg)', color: 'var(--kpi-hero-bg)',
          fontSize: 12, fontWeight: 700,
        }}>
          {DIRECTION_LABEL[net.direction] || ''}
        </span>
        <p style={{ margin: 0, fontSize: 12, lineHeight: 1.5, color: 'var(--kpi-hero-muted)', maxWidth: 420 }}>
          Everything up to the end of the selected range: what you earned on leads and clicks,
          minus leads you bought from us, adjusted for payments between us.
        </p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        {rows.map((row) => (
          <div key={row.key} style={rowStyle}>
            <span style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
              <span aria-hidden="true" style={{ width: 14, textAlign: 'center', fontWeight: 700, color: 'var(--kpi-hero-muted)' }}>
                {row.sign}
              </span>
              {row.swatch && <span aria-hidden="true" style={{ width: 10, height: 10, borderRadius: 3, background: row.swatch, flexShrink: 0 }} />}
              <span style={{ fontSize: 13 }}>{row.label}</span>
            </span>
            <span className="pw-num" style={{ fontSize: 14, fontWeight: 600 }}>
              <span className="pw-sr">{row.sign === '+' ? 'plus ' : 'minus '}</span>
              {money(row.amount)}
            </span>
          </div>
        ))}
        <div style={{ ...rowStyle, borderBottom: 0, fontWeight: 700 }}>
          <span style={{ fontSize: 13, paddingLeft: 24 }}>Net balance</span>
          <span className="pw-num" style={{ fontSize: 14 }}>
            {net.direction === 'you_owe_kickoff' ? '−' : ''}{money(net.amount)}
          </span>
        </div>

        {previous.map((p, i) => (
          <div key={i} style={{ ...rowStyle, borderBottom: 0, borderTop: '1px dashed rgba(148, 163, 184, 0.35)', marginTop: 4 }}>
            <span style={{ display: 'flex', flexDirection: 'column', paddingLeft: 24 }}>
              <span style={{ fontSize: 13 }}>Previous balance</span>
              <span style={{ fontSize: 11, color: 'var(--kpi-hero-muted)' }}>
                From before {dayLabel(p.as_of)} · {DIRECTION_LABEL[p.direction]} · not included above
              </span>
            </span>
            <span className="pw-num" style={{ fontSize: 14, fontWeight: 600 }}>{money(p.amount)}</span>
          </div>
        ))}
      </div>
    </section>
  )
}

const rowStyle = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
  padding: '10px 0', borderBottom: '1px solid rgba(148, 163, 184, 0.2)',
}
